module.exports = __webpack_public_path__ + "static/media/19ESCAP18.6593975a.jpg";